import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      flex: 1,
      flexGrow: 1,
      paddingTop: 50,
      '& .title': {
        fontSize: 40,
      },
      [theme.breakpoints.up('sm')]: {
        paddingTop: 100,
      },
    },
    message: {
      padding: '10px 0',
    },
    actions: {
      padding: '10px 0',
    },
  }),
);

export default useStyles;
